<template>
    <Modal class="" size="lg" @close="close" :customClass="customClass">
        <div class="mt-5 mb-4  items-center text-center text-[16px] md:text-[22px] font-normal">
            <h3 class="m-0 flex-1 font-bold text-[22px] md:text-[36px] mb-4 text-[#ff00a8]">
                VIGTIGT: Tilknyt en SoMe-konto nu!
            </h3>
            <p class="mb-4">
                For at kunne forbinde din profil, skal du logge ind med din Facebook-profil og samtidig have en Facebookside, der er forbundet med din Instagram Business-konto. Hvis du oplever problemer, så kan du se vores guide <a class="font-bold hover:underline text-blue-600" href="https://betterhype.com/wp-content/uploads/2025/02/Guide-for-Influencers_instagram_DK.pdf" target="_blank">her</a>.
            </p>
            <a href="/settings#channels" class="btn btn text-white mx-auto px-10 text-[20px]"
                style="background: rgb(255, 0, 168); border-radius: 0px;">TILKNYT NU</a>
        </div>
    </Modal>
</template>

<script type="text/babel">
import Modal from 'dashboard-js/components/Modal'
export default {
    props: {
        customClass: {
            type: String,
            default: 'connect-modal'
        }
    },
    methods: {
        close() {
            // Handle close event
            document.body.style.paddingRight = '';
            document.body.style.overflow = '';
            axios
                .post(route('influencer.settings.closeModal'))
                .then(response => {
                    // console.log(response)
                })
                .catch(error => {
                    console.error('Error deleting account:', error)
                })
        },
        connectNow() {
            window.location.href = '/settings#channels';
        }
    }
}
</script>

<style>
.ModalMask.connect-modal {
    background: rgba(255,0,168, 0.5) !important;
    &::before {
        display: none;
    }

    .Modal {
        box-shadow: none;
        border-radius: 0;
        padding: 80px 100px;
        border: none;
        width: max-content;
        max-width: 100%;
        position: relative;
        background-image: url('/img/bg-popup.png');
        background-size: cover;
        background-position: left center;
        background-color: transparent;
        @media( max-width: 768px) {
            padding: 60px;
        }
        /* &::after {
            content: '';
            position: absolute;
            top: 60px;
            left: -1px;
            width: 50px;
            bottom: -1px;
            clip-path: polygon(0 0, 35% 0, 100% 100%, 0% 100%);
            background: #ff00a8;
        } */

        button {
            top: 24px;
            right: 24px;
            svg {
                display: none;
            }

            .d-none {
                display: block;
            }
        }
    }
}
</style>